let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cnH73")).then(() => parcelRequire('15Wmh'));